import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
export default {
  name: 'smartControlTLog_page',
  props: {
    current: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '检测历史',
        queryFunName: 'smartControlTLogQuery'
      },
      searchForm: {
        page: 1,
        limit: 10,
        smartControlId: this.current.id,
        sortField: 'ts'
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      valueEnums: {},
      options: {},
      time: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
    };
  },
  mounted: function mounted() {
    this.query();
  },
  methods: {
    back: function back() {
      this.$emit('child-go-smartControl');
    },
    query: function query() {
      var _this = this;
      this.queryLoading = true;
      this.$api['smartControlItemQuery']({
        page: 1,
        limit: -1,
        smartControlId: this.current.id,
        sortField: '^sort'
      }).then(function (productRes) {
        _this.options = {};
        var _iterator = _createForOfIteratorHelper(productRes.data),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (item.valueType == 'Enums' && item.valueEnums) {
              item.valueEnums = JSON.parse(item.valueEnums);
            }
            _this.options[item.typeCode.toLowerCase()] = item;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var starDate, endDate;
        if (_this.time && _this.time.length) {
          starDate = _this.time[0];
          endDate = _this.time[1];
        }
        _this.$api[_this.pageConfig.queryFunName](_this.current.id, _objectSpread(_objectSpread({}, _this.searchForm), {}, {
          starDate: starDate,
          endDate: endDate
        })).then(function (res) {
          _this.tableData = res.data || [];
          _this.totalCount = res.count;
          _this.queryLoading = false;
        });
      });
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'ts';
      this.query();
    }
  }
};